import { Component, Vue } from "vue-property-decorator";

@Component
export default class ImageCompressor extends Vue {
  static compressImage(
    file: string,
    MAX_WIDTH: number,
    MAX_HEIGHT: number,
    format: string,
    response: Function
  ) {
    const img = new Image();
    img.src = file;
    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx: any = canvas.getContext("2d");

      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
      }

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      response(canvas.toDataURL("image/" + format));
    };
  }
}
